export default __webpack_public_path__ + "static/media/Mark-3-HUD-Label.5b8b0044.jpg";